export enum NetworkMetricsNames {
    APOLLO_GRAPHQL_ERROR = "apollo_graphql_error",
    APOLLO_NETWORK_ERROR = "apollo_network_error",
    APOLLO_API_LATENCY = "apollo_api_latency",
    APOLLO_API_REQUEST_COUNTER = "apollo_api_request_counter",
}
